import { Routes } from '@angular/router';
import { QuoteComponent } from './views/quote';
import { ErrorComponent } from './views/error';
import { MsalGuard } from '@azure/msal-angular';

export const routes: Routes = [
  { path: '', component: QuoteComponent, pathMatch: 'full', canActivate: [MsalGuard] },
  { path: 'error/:statusCode', component: ErrorComponent, pathMatch: 'full' },
];
